<template>
  <div>
    <div class="vx-row">
      <!-- MULTIPLE COLUMNS-->
      <div class="vx-col lg:w-4/4 w-full relative">
        <vx-card title="">
          <b-row><!--
            <b-col cols="3">
              <v-select
                :value="selected"
                v-model="selected"
                @input="ps"
                :options="options"
              ></v-select>
            </b-col>
            <b-col cols="2">
              <v-select
                :options="depoOptions"
                v-model="selectedDepo"
                label="DEPOTNAME"
                @input="ps"
              ></v-select>
            </b-col>-->
            <b-col cols="3" md="auto">
              <b-form-input v-model="siparisKod" @keyup.enter="siparisOku()" style="font-size: inherit" ref="barkodK"
                type="text" placeholder="Sipariş Kod" />
            </b-col>

            <b-col cols="3">
              <v-select v-model="selectedAnaSiparis" :options="optionsAnaSiparis" @input="getSecilenAnaUrun()"
                label="STOCKNAME"></v-select>
            </b-col>
            <b-col cols="3" md="auto">
              <b-form-input v-model="urunMiktar" @keyup.enter="miktarOku()" style="font-size: inherit" ref="barkodMik"
                type="text" placeholder="Miktar" />
            </b-col>
            <b-col cols="3" md="auto">
              <b-form-input v-model="urunKod" @keyup.enter="urunOku()" style="font-size: inherit" ref="barkodU"
                type="text" placeholder="Ürün Kod" />
            </b-col>

            <!--
            <b-col cols="3" md="auto">
              <vs-input
                class="inputx"
                placeholder="Ürün Kodu"
                @keyup.enter="barkodOku()"
                id="barkodM"
                :ref="barkod"
                v-model="barkod"
                autocomplete="off"
              />
            </b-col>-->
          </b-row>

          <div class="demo-alignment" style="font-weight: bold; color: green">
            <vs-button @click="siparisKontrol()" style="border-radius: 5px" color="dark" type="gradient">Sipariş
              Kaydet</vs-button>
            <vs-button @click="yazdir()" color="danger" style="border-radius: 5px" type="gradient">Yazdır</vs-button>
            <vs-button @click="faturaCikti()" color="primary" style="border-radius: 5px" type="gradient">Fatura
              Çıktısı</vs-button>
            <vs-button @click="activePromptTemizle = true" color="#fc9551" gradient-color-secondary="rgb(255, 115, 0)"
              style="border-radius: 5px" type="gradient">Listeyi Temizle</vs-button><!--
            <vs-button
              @click="sayimSifirla()"
              color="success"
              style="border-radius: 5px"
              type="gradient"
              v-if="!isMobile()"
              >Sayım Sıfırla</vs-button
            >
            <vs-button
              @click="stokListeAc()"
              style="border-radius: 5px"
              type="gradient"
              v-if="!isMobile()"
              >Stok Listesi</vs-button
            >-->
            <vs-button @click="sipararisListesi()" color="#bc49c4" gradient-color-secondary="rgb(110, 4, 138)"
              style="border-radius: 5px" type="gradient">Sipariş Listesi</vs-button>
            <span v-if="sipariseGoreUrunListesi.length > 0">
              <download-excel v-if="!isMobile()" class="btn btn-default" :data="sipariseGoreUrunListesi"
                name="siparisListesi.xls">
                Excel İndir
              </download-excel></span><!--
            <vs-button
              @click="topluKargoGonder()"
              color="#87b6b8"
              gradient-color-secondary="#5f9ea0"
              style="border-radius: 5px"
              type="gradient"
              v-if="!isMobile()"
              >Depo Kargo Gönder</vs-button
            >-->
          </div>
          <div class="demo-alignment" style="font-weight: bold; color: green" v-if="!isMobile()">
            <!--
            <label>Sayım Yap</label
            ><vs-switch style="border-radius: 20px" v-model="sayimDurumu" />
            <label>Kdv</label
            ><vs-switch style="border-radius: 20px" v-model="kdvDurumu" />-->
            <span style="color: green">Toplam Parça : {{ adetTopla() }} Adet</span><!--
            <span style="color: red">
              Toplam Tutar : {{ toplamTutar() }} TL</span
            >-->
            <vs-input class="inputx" type="hidden" id="barkodM" @keyup.enter="barkodOku()" :ref="barkodAdet"
              v-model="barkodAdet" />
          </div>
        </vx-card>

        <!--
        <vx-card title="" v-if="isMobile()">
          <div class="demo-alignment">
            <vs-input
              class="inputx"
              placeholder="Ürün Kodu"
              @keyup.enter="barkodOku()"
              id="barkodM"
              :ref="barkod"
              v-model="barkod"
              autocomplete="off"
            />
            <vs-button
              color="blue"
              :disabled="validated == 0"
              @click="bilgiler()"
              class="w-/4"
              >Bilgiler</vs-button
            >
            <vs-button
              color="red"
              :disabled="validated == 0"
              @click="stokListeAc()"
              class="w-2/4"
              >Stok Ara</vs-button
            >
          </div>
        </vx-card>-->
        <vx-card title="" style="margin-top: 10px">
          <vs-table search pagination max-items="15" :data="sipariseGoreUrunListesi" @selected="getStock"
            @dblSelection="handleSelected">
            <template slot="thead">
              <vs-th sort-key="STOCKNO">Ana Stok No</vs-th>
              <vs-th sort-key="STOCKNAME">Ana Stok Adı </vs-th>
              <vs-th sort-key="STOCKNAME">Ana Stok Miktar </vs-th>

              <vs-th sort-key="MIXNO">Reçete Stok No </vs-th>

              <vs-th sort-key="MIXNAME">Reçete Stok Adı </vs-th>
              <vs-th sort-key="mixqt">Reçete Stok Adet </vs-th>

              <vs-th sort-key="QUANTITY">Adet</vs-th>
              <vs-th sort-key="DQUANTITY">Okunan</vs-th>
              <vs-th sort-key="KALAN">Kalan</vs-th>
              <vs-th sort-key="LOTOKUNAN">Lot Okunan</vs-th>

              <vs-th sort-key="DEPOTNAME">Tarih</vs-th>

              <vs-th sort-key="STOCKTYPE">Durum</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :state="indextr == 0 ? 'success' : null" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].STOCKNO">
                  {{ data[indextr].STOCKNO }}
                </vs-td>
                <vs-td :data="data[indextr].STOCKNAME">
                  {{ data[indextr].STOCKNAME }}
                </vs-td>

                <vs-td :data="data[indextr].QREM">
                  {{ data[indextr].QREM }}
                </vs-td>
                <vs-td :data="data[indextr].MIXNO">
                  {{ data[indextr].MIXNO }}
                </vs-td>
                <vs-td :data="data[indextr].MIXNAME">
                  {{ data[indextr].MIXNAME }}
                </vs-td>
                <vs-td :data="data[indextr].mixqt">
                  {{ data[indextr].mixqt }}
                </vs-td>
                <vs-td :data="data[indextr].QUANTITY">
                  {{ data[indextr].QUANTITY }}
                </vs-td>
                <vs-td :data="data[indextr].DQUANTITY">
                  {{ data[indextr].DQUANTITY }}
                </vs-td>
                <vs-td :data="data[indextr].KALAN">
                  {{ data[indextr].KALAN }}
                </vs-td>
                <vs-td :data="data[indextr].lotqt" v-if="data[indextr].lotqt">
                  <vs-chip v-if="parseFloat(data[indextr].lotqt) > 0" color="warning">
                    {{ data[indextr].lotqt }}</vs-chip>
                </vs-td>
                <vs-td :data="data[indextr].lotqt" v-else> </vs-td>
                <vs-td :data="data[indextr].TRANSDATE">
                  {{ parseDate(data[indextr].TRANSDATE) }}
                </vs-td>

                <vs-td :data="data[indextr].qt" v-if="data[indextr].qt">
                  <vs-chip v-if="parseFloat(data[indextr].qt) > 0" color="success">
                    {{ data[indextr].qt }}</vs-chip>
                </vs-td>
                <vs-td :data="data[indextr].qt" v-else> </vs-td>
                <!--
                <vs-td :data="data[indextr].qt">
                  <Icon
                    icon="ic:baseline-remove-circle"
                    width="20"
                    height="20"
                    v-b-tooltip.hover.bottom="'Çıkar'"
                    color="#EA5455"
                    @click="removeFromList"
                  />
                </vs-td>-->
              </vs-tr>
              <vs-tr>
                <vs-td> </vs-td>
                <vs-td> </vs-td>
                <vs-td></vs-td>
                <vs-td> </vs-td>
                <vs-td style="font-weight: bold; color: black"> </vs-td>
                <vs-td> </vs-td>
                <vs-td> </vs-td>
                <vs-td> </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <div id="printMe" style="height: 1px; overflow: hidden; width: 100%">
            <template>
              <table style="width: 100% !important">
                <tr>
                  <th sort-key="stokkodu" style="border: 1px solid black; padding: 3px">
                    Stok Kodu
                  </th>

                  <th style="border: 1px solid black; padding: 3px">
                    Stok Adı
                  </th>
                  <th style="border: 1px solid black; padding: 3px">Depo</th>

                  <th style="border: 1px solid black; padding: 3px">
                    Adet Sayısı
                  </th>
                  <th style="border: 1px solid black; padding: 3px">
                    Adet Fiyatı
                  </th>

                  <th style="border: 1px solid black; padding: 3px">Toplam</th>
                </tr>

                <tr :key="indextr" v-for="(tr, indextr) in sipariseGoreUrunListesi">
                  <td style="border: 1px solid black; padding: 3px">
                    {{ tr.STOCKNO }}
                  </td>

                  <td style="border: 1px solid black; padding: 3px">
                    {{ tr.STOCKNAME }}
                  </td>
                  <td style="border: 1px solid black; padding: 3px">
                    {{ tr.DEPOTNAME }}
                  </td>
                  <td style="border: 1px solid black; padding: 3px">
                    {{ tr.QUANTITY }}
                  </td>

                  <td style="border: 1px solid black; padding: 3px">
                    {{ tr.NETPRICE }}
                  </td>

                  <td style="border: 1px solid black; padding: 3px">
                    {{ tr.TOTAL }}
                  </td>
                </tr>

                <tr>
                  <td style="border: 1px solid black; padding: 3px"></td>
                  <td style="border: 1px solid black; padding: 3px"></td>
                  <td style="border: 1px solid black; padding: 3px"></td>
                  <td style="border: 1px solid black; padding: 3px"></td>

                  <td style="border: 1px solid black; padding: 3px">
                    Toplam Adet
                  </td>
                  <td style="border: 1px solid black; padding: 3px">
                    {{ toplamAdet() }}
                  </td>
                </tr>
                <tr>
                  <td style="border: 1px solid black; padding: 3px"></td>
                  <td style="border: 1px solid black; padding: 3px"></td>
                  <td style="border: 1px solid black; padding: 3px"></td>
                  <td style="border: 1px solid black; padding: 3px"></td>

                  <td style="border: 1px solid black; padding: 3px">
                    Toplam Tutar
                  </td>
                  <!--
                  <td style="border: 1px solid black; padding: 3px">
                    {{ toplamTutar() }}
                  </td>-->
                </tr>
                <tr>
                  <td colspan="8" style="  border: 1px solid black;
                        padding: 3px;
                        text-align: right;
                      ">
                    Fiyatlarımıza KDV Dahil Değildir
                  </td>
                </tr>
                <tr>
                  <td colspan="8" style="border: 1px solid black; padding: 3px;  text-align: right;  ">
                    Siparişinizin geçerlilik süresi {{ gecerlilikTarihi }} mesai
                    bitimine kadardır.
                  </td>
                </tr>
              </table>
            </template>
          </div>
          <vs-prompt title="Adet İşlemleri" acceptText="Adet Gir" cancelText="Vazgeç" @accept="adetDegistir"
            :active.sync="activePrompt">
            <div class="con-exemple-prompt">
              <span>Adet</span>
              <vs-input type="number" placeholder="Sayı Giriniz" vs-placeholder="Code" v-model="partiVal"
                class="mt-3 w-full" />
            </div>
          </vs-prompt>
          <vs-prompt title="Sipariş İşlemleri" cancelText="Çıkış" acceptText="Onayla" :active.sync="activePromptSiparis"
            @accept="siparisYaz">
          </vs-prompt>
          <vs-prompt title="Sipariş İşlemleri" cancelText="Çıkış" acceptText="Sil" :active.sync="activePromptKontrol"
            @accept="kontrolOnayla">
            <p>Mix'de eksik kalan ürünler var bunlar silinsin mi?</p>
          </vs-prompt>

          <vs-prompt title="Sipariş Temizle" acceptText="Sipariş Temizle" cancelText="Vazgeç" @accept="listeyiTemizle"
            :active.sync="activePromptTemizle">
          </vs-prompt>
        </vx-card>
      </div>
    </div>
    <vs-card style="margin-top: 15px;">
      <iframe width="560" height="315" id="ciktiPdf" src="" frameborder="0"></iframe>

    </vs-card>
    <b-modal ref="modal-lotList" id="modal-primary" modal-class="modal-primary" centered title="Lot Listesi" size="md"
      hide-footer>
      <div class="con-exemple-prompt">
        <b-row>
          <b-col cols="12">
            <b-row style="padding: 0">
              <b-col style="padding: 0">
                <b-button v-if="miktarKontrolValidate == false" class="bg-primary" size="sm" v-on:click="repeateAgain()">
                  <Icon color="white" icon="material-symbols:add" width="20" height="20" />Ekle
                </b-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12">
            <b-row>
              <b-col cols="5">
                <p style="text-align: center">Lot Kodu</p>
              </b-col>
              <b-col cols="4">
                <p style="text-align: center">Miktar</p>
              </b-col>
              <b-col cols="2"> </b-col>
            </b-row>
          </b-col>

          <b-col cols="12">
            <div :class="scrollview" style="padding-right: 10px; height: 250px;">
              <b-row v-for="(item, index) in items" :id="item.id" :key="item.id" ref="row">
                <!-- Item Name -->
                <b-col cols="5" style="padding-right: 0">
                  <b-form-group label-for="cost">
                    <v-select :options="lotOptions" v-model="item.lotKodu" :disabled="item.disabled" ref="barkodK"
                      placeholder="Kod" autocomplete>
                      <template slot="option" slot-scope="option">
                        {{ option.LOTNO }} ({{ option.QREM }})
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        {{ option.LOTNO }} ({{ option.QREM }})
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>
                <b-col cols="4" style="padding-right: 0">
                  <b-form-group label-for="cost">
                    <b-form-input v-model="item.lotMiktar" style="font-size: inherit" id="cost" type="text"
                      placeholder="Miktar" />
                  </b-form-group>
                </b-col>

                <!-- Quantity onayKontrol-->

                <b-col style="padding-right: 0" cols="2" class="mb-50">
                  <b-row>
                    <b-col style="padding-right: 0" cols="6" class="mb-50">
                      <b-row style="padding: 0">
                        <b-col style="padding: 0">
                          <b-button :disabled="item.disabled" variant="outline-light" size="sm"
                            v-on:click="addTanim(index)">
                            <Icon color="#28c76f" icon="ic:baseline-save-all" width="20" height="20" />
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col cols="6" class="mb-50">
                      <b-row style="padding: 0">
                        <b-col style="padding: 0">
                          <b-button variant="outline-light" size="sm" v-on:click="removeTanim(index)">
                            <Icon color="#EA5455" icon="ic:baseline-remove-circle" width="20" height="20" />
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
                <!-- Remove Button -->

                <b-col cols="12" style="height: 5px"> </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col>
            <vs-button v-if="miktarKontrolValidate == false" @click="lotsKaydet()" color="danger"
              type="filled">Kaydet</vs-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <vs-popup fullscreen class="holamundo" title="Renk Seçenekleri" :active.sync="popupRenk">
      <vs-table :data="ciktiRenkListesi">
        <template slot="thead">
          <vs-th sort-key="STOK_KODU">Stok Kodu</vs-th>
          <vs-th sort-key="renk">Renk</vs-th>
          <vs-th sort-key="depoAdet">Depo Adet</vs-th>
          <vs-th sort-key="stokkodu">Ekle</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].STOK_KODU">
              {{ data[indextr].STOK_KODU }}
            </vs-td>
            <vs-td :data="data[indextr].renk">
              {{ data[indextr].renk }}
            </vs-td>
            <vs-td :data="data[indextr].depoAdet">
              {{ data[indextr].depoAdet }}
            </vs-td>

            <vs-td>
              <vs-button @click="satirEkle(data[indextr].barkod)" color="red" type="filled">Ekle</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>

    <vs-popup fullscreen class="holamundo" title="Renk Seçenekleri" :active.sync="popupPaket">
      <vs-table :data="ciktiPaketListesi">
        <template slot="thead">
          <vs-th sort-key="STOK_KODU">Stok Kodu</vs-th>
          <vs-th sort-key="STOK_ADI">Stok Adı</vs-th>
          <vs-th sort-key="adet">Adet</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].STOK_KODU">
              {{ data[indextr].STOK_KODU }}
            </vs-td>
            <vs-td :data="data[indextr].STOK_ADI">
              {{ data[indextr].STOK_ADI }}
            </vs-td>
            <vs-td :data="data[indextr].depoAdet">
              {{ data[indextr].adet }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>

    <vs-popup fullscreen class="holamundo" title="Satış Bilgileri" :active.sync="popupBilgiler">
      <table>
        <tr>
          <td>Cari</td>
          <td>
            <v-select :value="selected" v-model="selected" @input="ps" :options="options"></v-select>
          </td>
        </tr>
        <tr>
          <td>Depo</td>
          <td>
            <v-select :options="['10', '11', '12', '50']" v-model="selectedDepo" @input="ps"></v-select>
          </td>
        </tr>

        <tr>
          <td>Kontrol</td>
          <td>
            <vs-input class="inputx" placeholder="Kontrol" id="kontrol" @keyup.enter="kontrol()" :ref="barkodAdetKontrol"
              v-model="barkodAdetKontrol" />
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <span style="color: green">Toplam Parça : {{ adetTopla() }} Adet</span><!--
            <span style="color: red">
              Toplam Tutar : {{ toplamTutar() }} TL</span
            >-->
          </td>
        </tr>
        <tr>
          <td>
            <vs-button @click="activePromptTemizle = true" color="warning" type="filled" v-if="isMobile()">Listeyi
              Temizle</vs-button>
          </td>
          <td><label>Sayım Yap</label><vs-switch v-model="sayimDurumu" /></td>
        </tr>
      </table>
    </vs-popup>

    <vs-popup fullscreen class="holamundo" title="Stok Listesi" :active.sync="popupStokListesi">
      <vs-input class="inputx" placeholder="Barkod" @keyup.enter="stokListesi()" :ref="barkodListe"
        v-model="barkodListe" />
      <vs-table :data="dataStokListesi">
        <template slot="thead">
          <vs-th sort-key="stokKodu">Stok Kodu</vs-th>
          <vs-th sort-key="stokAdet">Stok Adet</vs-th>
          <vs-th sort-key="renk">Renk</vs-th>
          <vs-th sort-key="beden">Beden</vs-th>

          <vs-th></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].orderNumber">
              {{ data[indextr].stokKodu }}
            </vs-td>

            <vs-td :data="data[indextr].quantity">
              {{ data[indextr].stokAdet }}
            </vs-td>
            <vs-td :data="data[indextr].musteriAdi">
              {{ data[indextr].renk }}
            </vs-td>
            <vs-td :data="data[indextr].merchantSku">
              {{ data[indextr].beden }}
            </vs-td>

            <vs-td>
              <vs-button @click="satirEkle(data[indextr].Barkod)" color="success" type="filled">Ekle</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>

    <vs-popup fullscreen class="holamundo" title="Sipariş Listesi" :active.sync="popupSiparisListesi">
      <vs-table search pagination max-items="15" :data="dataSiparisListesi" @dblSelection="handleSiparisSelected"
        @touchstart="handleSiparisSelected">
        <template slot="thead">
          <vs-th sort-key="RECEIPTNO">Sipariş No</vs-th>
          <vs-th sort-key="ACTNAME">Cari</vs-th>
          <vs-th sort-key="GROUPCODE">Grup Kodu</vs-th>

          <vs-th sort-key="DESCRIPTION">Cari</vs-th>
          <vs-th sort-key="TRANSDATE">Tarih</vs-th>
          <vs-th>Depo</vs-th>
          <vs-th v-if="isMobile"></vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].RECEIPTNO">
              {{ data[indextr].RECEIPTNO }}
            </vs-td>
            <vs-td :data="data[indextr].ACTNAME">
              {{ data[indextr].ACTNAME }}
            </vs-td>
             <vs-td :data="data[indextr].GROUPCODE">
              {{ data[indextr].GROUPCODE }}
            </vs-td>
            <vs-td :data="data[indextr].DESCRIPTION">
              {{ data[indextr].DESCRIPTION }}
            </vs-td>
            <vs-td :data="data[indextr].TRANSDATE">
              {{ parseDate(data[indextr].TRANSDATE) }}
            </vs-td>
            <vs-td :data="data[indextr].DEPOTNAME">
              {{ data[indextr].DEPOTNAME }}
            </vs-td>
            <vs-td v-if="isMobile">
              <vs-button @click="handleSiparisSelected(tr)" color="success" type="filled">Ekle</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from "vue-select";
import state from "../../store/state";
import Store from "../../store/store";
import { isMobile } from "mobile-device-detect";
import { Icon } from "@iconify/vue2";
import { StreamBarcodeReader } from "vue-barcode-reader";
import moment from "moment";
export default {
  components: {
    Icon,
    "v-select": vSelect,
    StreamBarcodeReader
  },
  created() {
    this.getDepo();
    this.scrollview = "scroll-hand";
  },
  data() {
    return {
      uyumsuzMix: [],
      DEPOTID: "",
      RECEIPTID: "",
      RECEIPTNO: "",
      miktarKontrolValidate: false,
      kaydedilenLots: [],
      lotOptions: [],
      secilenStok: [],
      items: [
        {
          id: 0,
          lotKodu: "",
          lotMiktar: "",
          kod: "",
          disabled: false,
          ROOT: "",
          ROOTFIELD: "",
          STOCKLOTSID: "",
          COMPANYID: "",
          STOCKID: ""
        }
      ],
      scrollview: "",
      activePromptLot: false,
      selectedAnaSiparis: "",
      siparisYazdirKontrol: false,
      optionsAnaSiparis: [],
      urunKod: "",
      urunMiktar: "",
      siparisKod: "",
      depoOptions: [],
      //  listeKontrol: false,
      siparisAciklama: "",
      siparisAciklama1: "",
      siparisAciklama2: "",
      active: false,
      adetKod: "",
      text: "0",
      id: null,
      sayimDurumu: false,
      kdvDurumu: false,
      popupBilgiler: false,
      popupStokListesi: false,
      popupSiparisListesi: false,
      popupPaket: false,
      options: [],
      optionsParti: [],
      pazaryeriTum: [],
      list: [],
      dataStokListesi: [],
      dataSiparisListesi: [],
      ciktiRenkListesi: [],
      ciktiPaketListesi: [],
      listSonFaturalar: [],
      listSiparis: [],
      sipariseGoreUrunListesi: [],
      progress: 0,
      activePrompt: false,
      activePromptSiparis: false,
      activePromptKontrol: false,
      activePromptTemizle: false,
      popupRenk: false,
      pazaryeriVal: "",
      partiVal: "",
      toplamParca: 0,
      selected: { id: 0, label: "Cari" },
      selectedDepo: "",
      iadeModel: { id: 0, label: "İade red" },
      selectedParti: { id: 0, label: "Parti Nolar" },
      popupActive: false,
      popupFatura: false,
      popupActiveSiparis: false,
      popupActiveCikti: false,
      barkod: "",
      barkodAdet: "",
      cariKod: "",
      siparisBulOrderNumber: "",
      genelSiparisNo: "",

      genelKargoAdi: "",
      genelKargoNo: "",
      genelMusteri: "",
      hediyeMi: 0,
      genelToplam: 0,
      eklenenDeger: "",
      indext: 0,
      indext1: 0,
      urunResim: "",
      validated: 1,
      validatedF: 1,
      siparisToplamParca: 0,
      eklenenToplamParca: 0,
      askiDurumu: false,
      aski: 0,
      imageLink: "",
      ciktiListesi: [],
      jsonD: "",
      dr: "",
      popupActiveFaturaCikti: false,
      receiptId: 0,
      faturaNo: "",
      ilkOkuma: 0,
      recId: 0,
      total: 0,
      faturaAranan: "",
      faturaBulOrderNumber: "",
      im: 0,
      iadeOrderNumber: "",
      iadeLineItemId: "",
      barkodAdetKontrol: "",
      ustBolumDeger: 0,
      barkodListe: "",
      kontrolAdetSistem: 0,
      secilenKod: "",
      aramaKontrol: "",
      tarihs: "",
      gecerlilikTarihi: ""
    };
  },
  methods: {
    getStock(tr) {
    //  this.urunMiktar = tr.QUANTITY
      this.selectedAnaSiparis = tr.STOCKNO
    },
    handleSiparisSelected(tr) {
      console.log(tr);
      this.urunKod = "";
      this.selectedAnaSiparis = "";
      this.urunMiktar = "";
      this.siparisKod = tr.RECEIPTNO;
      this.receiptId = tr.RECEIPTID;
      this.siparisOku();
      this.popupSiparisListesi = false;
    },
    lotsKaydet() {
      var vm = this;
      var vs = this.$vs;
      let toplamLotMikk = 0.0;
      let kontrolForLot = false;
      console.log(vm.items);
      let miktarUyumKontrol = vm.items.filter(post => {
        return post.STOCKID == vm.secilenStok.MIXID;
      });
      miktarUyumKontrol.forEach((val, index) => {
        toplamLotMikk += parseFloat(val.lotMiktar);
      });
      console.log(toplamLotMikk);
      console.log(vm.secilenStok.qt);

      if (parseFloat(vm.secilenStok.qt) == toplamLotMikk) {
        kontrolForLot = true;
      } else {
        kontrolForLot = false;
      }

      if (kontrolForLot.toString().includes("false") == true) {
        vs.notify({
          title: "Lot İşlemi",
          text: "Eksik ya da Fazla lot girişi yaptınız",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-right"
        });
      } else {
        vm.items.forEach((val, index) => {
          if (val.disabled == true) {
            const soap = require("soap");
            let url = state.sistemAddress;
            url = url.replace("sistem", "uzumMrp");
            console.log(val.lotKodu);
            const args = {
              token: Store.state.tokenId,
              ISLEM: "UPT",
              ROOT: "103",
              RECEIPTNO: vm.RECEIPTNO,
              STOCKID: vm.secilenStok.STOCKID,
              ITEMNO: vm.secilenStok.ITEMNO,
              LOTID: val.STOCKLOTSID,
              QUANTITY: vm.secilenStok.QUANTITY,
              RECEIPTID: vm.RECEIPTID,
              MIXSTOCK: vm.secilenStok.MIXID,
              MIXOKUNAN: vm.secilenStok.qt,
              LOTOKUNAN: val.lotMiktar,
              LOTNO: val.lotKodu.LOTNO,
              LOTDEPO: val.lotKodu.DEPOTID
            };
            console.log(args);
            soap.createClient(url, function (err, client) {
              client.addTempOrder(args, function (err, result) {
                vm.veriler = JSON.parse(result.addTempOrderResult);
                vm.siparisOku();
                vm.$refs["modal-lotList"].hide();
              });
            });
          }
        });
      }
    },
    repeateAgain() {
      this.items.push({
        id: 1,
        disabled: false
      });
      //  this.$nextTick(() => this.$refs.barkodK[0].focus());
    },
    getLots(STOCKID, DEPOTID) {
      var vm = this;
      var vs = this.$vs;

      vm.veriler = [];

      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        token: Store.state.tokenId,
        STOCKID: STOCKID,
        DEPOTID: DEPOTID
      };
      soap.createClient(url, function (err, client) {
        client.STOCKLOTSLIST(args, function (err, result) {
          if (result.STOCKLOTSLISTResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.STOCKLOTSLISTResult);
          try {
            if (vm.veriler.response == "Ok") {
              let lotsList = JSON.parse(vm.veriler.jsonData);
              vm.lotOptions = [];
              lotsList.forEach((val, index) => {
                if (Math.sign(val.QREM) == 1) {
                  vm.lotOptions.push(val);
                }
              });
            } else {
              vs.notify({
                title: "Reçete Listesi",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-right"
              });
            }
          } catch (error) {
            /*  vs.notify({
              title: "Reçete Listesi",
              text: "Beklenmedik Hata",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });*/
          }
        });
      });
    },
    removeTanim(index) {
      var vm = this;
      var vs = this.$vs;

      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        token: Store.state.tokenId,
        ISLEM: "DEL",
        RECEIPTID: this.RECEIPTID,
        MIXSTOCK: this.secilenStok.MIXID
      };

      soap.createClient(url, function (err, client) {
        client.addTempOrder(args, function (err, result) {
          if (result.addTempOrderResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.addTempOrderResult);
          try {
            if (vm.veriler.response == "Ok") {
              let lotsList = JSON.parse(vm.veriler.jsonData);

              vm.getLotForStock(vm.secilenStok.MIXID, vm.RECEIPTID);
              vm.siparisOku();
              vs.notify({
                title: "Reçete Listesi",
                text: "Silindi",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-right"
              });
            } else {
              vs.notify({
                title: "Reçete Listesi",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-right"
              });
            }
          } catch (error) {
            console.log(error);
            /*  vs.notify({
              title: "Reçete Listesi",
              text: "Beklenmedik Hata",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });*/
          }
        });
      });
    },
    addTanim(index, islem) {
      var vm = this;
      let toplamLotMikk = 0.0;
      var vs = this.$vs;
      vm.veriler = [];
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      if (islem == "DEL") {
      } else {
        if (
          vm.items[index].lotKodu == "" ||
          typeof vm.items[index].lotKodu == "undefined"
        ) {
          vs.notify({
            title: "Lot Ekleme",
            text: "Kod alanı zorunludur",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-right"
          });
        } else if (
          vm.secilenStok.qt == "" ||
          typeof vm.secilenStok.qt == "undefined" ||
          vm.secilenStok.qt == null
        ) {
          vs.notify({
            title: "Lot Ekleme",
            text: "Herhangibir ürün okutmadınız",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-right"
          });
        } else if (vm.secilenStok.length == 0) {
          vs.notify({
            title: "Lot Ekleme",
            text: "Stok seçimi yapmadınız",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-right"
          });
        } else {
          let bulunan = [];
          let deger = 0;
          let filteredItem = vm.items.filter(post => {
            return (
              vm.items[index].lotKodu.LOTNO.toUpperCase() ==
              post.lotKodu.LOTNO.toUpperCase() &&
              post.STOCKID == vm.secilenStok.MIXID
            );
          });

          if (filteredItem.length > 0) {
            vs.notify({
              title: "Lot Ekleme",
              text: "Lot kodu daha önce kullanılmış",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-right"
            });
          } else {
            let kontrolForLot = false;

            if (vm.secilenStok.FOLLOWLOT == true) {
              let miktarUyumKontrol = vm.items.filter(post => {
                return post.STOCKID == vm.secilenStok.MIXID;
              });

              miktarUyumKontrol.forEach((val, index) => {
                toplamLotMikk += parseFloat(val.lotMiktar);
              });

              if (parseFloat(vm.secilenStok.qt) == toplamLotMikk) {
                kontrolForLot = true;
              } else {
                kontrolForLot = false;
              }
            }

            if (kontrolForLot.toString().includes("true") == true) {
              vs.notify({
                title: "Lot İşlemi",
                text: "Fazla lot girişi yaptınız",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-right"
              });
            } else {
              const args = {
                token: Store.state.tokenId,
                COMPANYID: state.MusteriId,
                STOCKID: vm.secilenStok.MIXID,
                LOTNO: vm.items[index].lotKodu.LOTNO,
                ISLEM: islem,
                DEPOTID: vm.secilenStok.depo
              };

              soap.createClient(url, function (err, client) {
                client.STOCKLOTSLIST(args, function (err, result) {
                  if (result.STOCKLOTSLISTResult == "-1") {
                    Store.dispatch("logout");
                    //this.$store.dispatch('login', payload)
                  }
                  try {
                    vm.veriler = JSON.parse(result.STOCKLOTSLISTResult);
                    let lotListesi = JSON.parse(vm.veriler.jsonData);
                    if (vm.veriler.response == "Ok") {
                      /* vs.notify({
                        title: "Lot Ekleme",
                        text: vm.veriler.message,
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success",
                        position: "top-right"
                      });*/
                      if (lotListesi.length > 0) {
                        let mikTanim = 0;
                        /*  let rowData5 = [];
                        vm.gridApi.forEachNode(node =>
                          rowData5.push(node.data)
                        );*/

                        if (
                          typeof vm.items[index].lotMiktar == "undefined" ||
                          vm.items[index].lotMiktar == "" ||
                          vm.items[index].lotMiktar == null
                        ) {
                          /* vm.items[index].lotMiktar = 0.0;
                          if (lotListesi[0].QREM < vm.secilenStok.qt) {
                            vm.items[index].lotMiktar =
                              parseFloat(lotListesi[0].QREM) - toplamLotMikk;
                          } else {
                            vm.items[index].lotMiktar =
                              parseFloat(vm.secilenStok.qt) -
                              (parseFloat(lotListesi[0].QREM) + toplamLotMikk);
                          }*/
                          vs.notify({
                            title: "Lot Ekleme",
                            text: "Miktar giriniz",
                            iconPack: "feather",
                            icon: "icon-alert-circle",
                            color: "warning",
                            position: "top-right"
                          });
                        } else if (
                          parseFloat(vm.items[index].lotMiktar) +
                          toplamLotMikk >
                          parseFloat(vm.secilenStok.qt)
                        ) {
                          vs.notify({
                            title: "Lot Ekleme",
                            text:
                              "Girilen lot miktarı okunan miktardan büyük olamaz",
                            iconPack: "feather",
                            icon: "icon-alert-circle",
                            color: "warning",
                            position: "top-right"
                          });
                        } else {
                          if (
                            parseFloat(vm.items[index].lotMiktar) <
                            parseFloat(lotListesi[0].QREM)
                          ) {
                            vm.items[index].lotMiktar = parseFloat(
                              vm.items[index].lotMiktar
                            );
                          } else {
                            vm.items[index].lotMiktar = parseFloat(
                              lotListesi[0].QREM
                            );
                          }
                          //    vm.items[index].lotMiktar = vm.items[index].lotMiktar;

                          vm.items[index].disabled = true;
                          vm.items[index].ROOT = vm.secilenStok.RECEIPTID;
                          vm.items[index].DEPOTID = lotListesi[0].DEPOTID;
                          vm.items[index].STOCKLOTSID =
                            lotListesi[0].STOCKLOTSID;
                          vm.items[index].STOCKID = vm.secilenStok.MIXID;
                          vm.items.push({
                            id: index + 1,
                            disabled: false
                          });
                        }
                      } else {
                        vs.notify({
                          title: "Lot Ekleme",
                          text:
                            "Lot kaydının sistemden kayıtlı olduğundan emin olun",
                          iconPack: "feather",
                          icon: "icon-alert-circle",
                          color: "danger",
                          position: "top-right"
                        });
                      }
                    } else
                      vs.notify({
                        title: "Lot Ekleme",
                        text:
                          "Lot kaydının sistemden kayıtlı olduğundan emin olun",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "danger",
                        position: "top-right"
                      });
                  } catch (error) {
                    console.log(error);
                    vs.notify({
                      title: "Lot Ekleme",
                      text: "Lot Kaydı sırasında hata oluştu",
                      iconPack: "feather",
                      icon: "icon-alert-circle",
                      color: "danger",
                      position: "top-right"
                    });
                  }
                });
              });
            }
          }
        }
      }
    },
    getLotForStock(MIXID, RECEIPTID, STOCKID) {
      var vm = this;
      var vs = this.$vs;

      vm.veriler = [];
      vm.items = [];

      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        token: Store.state.tokenId,
        STOCKID: MIXID,
        ANASTOCKID: STOCKID,
        RECEIPTID: RECEIPTID
      };

      soap.createClient(url, function (err, client) {
        client.listTempOrder(args, function (err, result) {
          if (result.listTempOrderResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.listTempOrderResult);
          try {
            if (vm.veriler.response == "Ok") {
              let lotsList = JSON.parse(vm.veriler.jsonData);

              if (lotsList.length > 0) {
                lotsList.forEach((val, index) => {
                  if (val.LOTID != 0) {
                    vm.items.push({
                      id: index,
                      lotKodu: { LOTNO: val.LOTNO },
                      lotMiktar: val.LOTOKUNAN,
                      kod: "",
                      disabled: false,
                      ROOT: val.secilenStok,
                      ROOTFIELD: "",
                      STOCKLOTSID: val.STOCKLOTSID,
                      COMPANYID: "",
                      STOCKID: val.STOCKID
                    });
                  } else {
                    vm.items = [
                      {
                        id: 0,
                        lotKodu: "",
                        lotMiktar: "",
                        kod: "",
                        disabled: false,
                        ROOT: "",
                        ROOTFIELD: "",
                        STOCKLOTSID: "",
                        COMPANYID: "",
                        STOCKID: ""
                      }
                    ];
                  }
                });
              } else {
              }
            } else {
              vs.notify({
                title: "Reçete Listesi",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-right"
              });
            }
          } catch (error) {
            console.log(error);
            /*  vs.notify({
              title: "Reçete Listesi",
              text: "Beklenmedik Hata",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });*/
          }
        });
      });
    },
    handleSelected(tr) {
      this.secilenStok = tr;

      this.getLots(tr.MIXID, tr.depo);
      //   this.activePromptLot = true;
      console.log(tr);
      this.getLotForStock(tr.MIXID, tr.RECEIPTID, tr.STOCKID);
      this.repeateAgain();

      this.$refs["modal-lotList"].show();
    },

    miktarOku() {
      this.$refs["barkodU"].focus();
    },
    removeFromList() { },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY");
    },
    getSecilenAnaUrun() {
      this.$refs["barkodMik"].focus();
    },
    getDepo() {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        token: Store.state.tokenId
      };
      soap.createClient(url, function (err, client) {
        client.DEPOLIST(args, function (err, result) {
          if (result.DEPOLISTResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.DEPOLISTResult);
          const list = JSON.parse(vm.veriler.jsonData);

          vm.depoOptions = list;
          vm.$refs["barkodK"].focus();
        });
      });
    },
    hataMuzik() {
      let url = state.sistemAddress;
      url = url.replace("sistem.asmx?WSDL", "ses/");
      var audio = new Audio(url + "hata.wav");
      audio.play();
    },
    onayMuzik() {
      let url = state.sistemAddress;
      url = url.replace("sistem.asmx?WSDL", "ses/");
      var audio = new Audio(url + "ok.wav");
      audio.play();
    },
    adetStokKod(kod) {
      //alert(kod)
      this.secilenKod = kod;
    },
    sortArrays(arrays) {
      return _.orderBy(arrays, "id", "asc");
    },
    sortArrays1(arrays) {
      return _.orderBy(arrays, "guncellemeTarihi", "desc");
    },
    stokListeAc() {
      this.stokListesi();
      this.popupStokListesi = true;
    },
    topluKargoGonder() {
      const vs = this.$vs;
      if (this.selected.id == 0) {
        vs.notify({
          title: "Cari",
          text: "Cari seçiniz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else {
        const args = {
          cariKodu: this.selected.id,
          paketAdedi: "1"
        };
        soap.createClient(url, function (err, client) {
          client.toptanHepsiJetUrunGonder(args, function (err, result) {
            vm.veriler = JSON.parse(result.toptanHepsiJetUrunGonderResult);
            if (vm.veriler.response == "Ok") {
              vs.notify({
                title: "Gönderildi",
                text: "Depo kargo gönderimi başarılı.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center"
              });
            } else {
              vs.notify({
                title: "Hata",
                text: "Depo kargo gönderimi hatalı.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "red",
                position: "top-center"
              });
            }
          });
        });
      }
    },
    sipararisListesi() {
      console.log("in")
      this.dataSiparisListesi = [];
      //this.dataStokListesi=null
      var vm = this;
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");

      const args = {};
      soap.createClient(url, function (err, client) {
        client.getOrderList(args, function (err, result) {
          vm.veriler = JSON.parse(result.getOrderListResult);
          vm.dataSiparisListesi = JSON.parse(vm.veriler.jsonData);
          console.log(vm.dataSiparisListesi)
          vm.popupSiparisListesi = true;
        });
      });
    },
    stokListesi() {
      this.dataStokListesi = [];
      //this.dataStokListesi=null
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
        kod: vm.barkodListe,
        pazaryeri: "",
        depoNo: this.selectedDepo
      };
      soap.createClient(url, function (err, client) {
        client.stokListesiToptan(args, function (err, result) {
          if (result.stokListesiToptanResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.stokListesiToptanResult);
          vm.dataStokListesi = vm.veriler;
        });
      });
    },
    bilgiler() {
      this.popupBilgiler = true;
    },
    barkodAc() {
      this.text = "";
    },
    ustBolumDegistir() {
      if (this.ustBolumDeger == 1) {
        document.getElementById("ustBolum").style.height = "100px";
        this.ustBolumDeger = 0;
      } else {
        document.getElementById("ustBolum").style.height = "0px";
        this.ustBolumDeger = 1;
      }
    },
    onDecode(a, b, c) {
      if (this.text == "") {
        this.barkod = a;
        this.barkodOku();
      }
      /* if (this.id) clearTimeout(this.id);
        this.id = setTimeout(() => {
          if (this.text === a) {
            this.text = "";
          }
        }, 5000);*/
    },
    onLoaded() {
      // console.log("load");
    },
    satirEkle(barkod) {
      //alert(barkod)
      // this.listeKontrol = true;
      this.barkod = barkod;
      this.barkodOku();
      this.popupRenk = false;
    },
    renkListesi(ortakKod) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      //console.log(this.pazaryeriVal.trim()+"**"+this.partiVal+"**"+vm.barkod+"**"+this.aski+"**"+gelenorder+"**"+Store.state.tokenId)

      const args = { ortakKod: ortakKod, depoKodu: this.selectedDepo };
      soap.createClient(url, function (err, client) {
        client.hizliSiparisRenkListesi(args, function (err, result) {
          vm.veriler = JSON.parse(result.hizliSiparisRenkListesiResult);

          vm.ciktiRenkListesi = vm.veriler;
        });
      });

      vm.popupRenk = true;
    },
    paketListesi(stokKodu) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      //console.log(this.pazaryeriVal.trim()+"**"+this.partiVal+"**"+vm.barkod+"**"+this.aski+"**"+gelenorder+"**"+Store.state.tokenId)

      const args = { stokKodu: stokKodu };
      soap.createClient(url, function (err, client) {
        client.paketIcerigi(args, function (err, result) {
          vm.veriler = JSON.parse(result.paketIcerigiResult);

          vm.ciktiPaketListesi = vm.veriler;
        });
      });

      vm.popupPaket = true;
    },
    getNow: function () {
      const today = new Date();
      const date =
        today.getDate() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getFullYear();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date + " " + time;
      return dateTime;
    },
    adetTopla() {
      let toplam = 0;
      if (
        (this.sipariseGoreUrunListesi != null) &
        (this.sipariseGoreUrunListesi != "")
      ) {
        this.sipariseGoreUrunListesi.forEach(element => {
          toplam = toplam + parseInt(element.QUANTITY);
        });
      }
      return toplam;
    },
    toplamTutar() {
      let toplam = 0;
      if (
        (this.sipariseGoreUrunListesi != null) &
        (this.sipariseGoreUrunListesi != "")
      ) {
        this.sipariseGoreUrunListesi.forEach(element => {
          toplam += element.TOTAL;
        });
      }
      return toplam;
    },
    toplamAdet() {
      let toplam = 0;
      if (
        (this.sipariseGoreUrunListesi != null) &
        (this.sipariseGoreUrunListesi != "")
      ) {
        this.sipariseGoreUrunListesi.forEach(element => {
          toplam = toplam + parseFloat(element.QUANTITY);
        });
      }
      return toplam;
    },
    toplamTutarKdv() {
      let toplam = 0;
      if (
        (this.sipariseGoreUrunListesi != null) &
        (this.sipariseGoreUrunListesi != "")
      ) {
        this.sipariseGoreUrunListesi.forEach(element => {
          toplam = toplam + parseFloat(element.adet * element.SATIS_FIAT1);
        });
      }
      return Math.round(toplam * 1.10 * 100) / 100;
    },
    kontrol() {
      const vm = this;
      const vs = this.$vs;
      vm.barkod = vm.barkod.toUpperCase();
      //console.log(vm.sipariseGoreUrunListesi)
      vm.indext = vm.indexbul(
        vm.sipariseGoreUrunListesi,
        item => item.barkod === vm.barkod
      );

      if (vm.sayimDurumu === true) {
        //alert(vm.indext)

        // alert(vm.indext)
        // alert(vm.sipariseGoreUrunListesi[vm.indext].eklenen)
        // alert(vm.indext)
        if (vm.indext == -1) {
          //  var audio = new Audio('file://D://TKM1010019a.mp3'); // path to file
          //    audio.play();
          vm.hataMuzik();
          vs.notify({
            title: "Paketleme",
            text: "Okutulan Ürün Sipariş Listesinde Yok",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center"
          });
        } else {
          if (
            vm.sipariseGoreUrunListesi[vm.indext].kontrolAdet >=
            vm.sipariseGoreUrunListesi[vm.indext].adet
          ) {
            vm.hataMuzik();
            vs.notify({
              title: "Paketleme",
              text: "Lütfen Fazla Ürün Okutmayınız",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "red",
              position: "top-center"
            });
          } else {
            vm.onayMuzik();

            vm.sipariseGoreUrunListesi[vm.indext].kontrolAdet =
              vm.sipariseGoreUrunListesi[vm.indext].kontrolAdet + 1;
            if (
              vm.sipariseGoreUrunListesi[vm.indext].kontrolAdet <
              vm.sipariseGoreUrunListesi[vm.indext].kontrolAdet + 1
            ) {
              // alert(vm.sipariseGoreUrunListesi[vm.indext].kontrolAdet)
              vm.kontrolAdetGuncelle(
                vm.barkodAdetKontrol,
                vm.sipariseGoreUrunListesi[vm.indext].kontrolAdet,
                vm.indext
              );
              //console.log(vm.tarihs)
            }
          }
        }
      } else {
        vm.ps();
      }
      vm.barkod = "";
      //  document.getElementById("barkodM").focus();
    },
    kontrolAdetGuncelle(barkod, adet, index) {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        cariKodu: this.selected.id,
        depoKodu: this.selectedDepo,
        barkod: barkod,
        adet: adet
      };
      // console.log(args)
      soap.createClient(url, function (err, client) {
        client.kontrolAdetGuncelle(args, function (err, result) {
          //console.log(result.kontrolAdetGuncelleResult)
          vm.veriler = JSON.parse(result.kontrolAdetGuncelleResult);

          vm.sipariseGoreUrunListesi[index].guncellemeTarihi =
            vm.veriler[0].guncellemeTarihi;
        });
      });
    },
    sayimSifirla(barkod, adet) {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = { cariKodu: this.selected.id, depoKodu: this.selectedDepo };

      soap.createClient(url, function (err, client) {
        client.sayimSifirla(args, function () {
          vm.ps();
        });
      });
    },
    faturaCikti() {
      console.log(Store.state.printAddress2 +
        this.receiptId.toString().replace("'", "") +
        "&Tr=")
      document.getElementById("ciktiPdf").src =
        Store.state.printAddress2 +
        this.receiptId +
        "&Tr=";
    },
    yazdir() {
      setTimeout(this.yazdirBekle, 1000);
    },
    yazdirBekle() {
      this.$htmlToPaper("printMe");
    },
    siparisYaz1() {
      this.kdvDurumu = true;
      this.siparisYaz(1);
    },
    addLotsList(index, list) {
      var vm = this;
      var vs = this.$vs;
      vm.veriler = [];

      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");

      if (index == vm.kaydedilenLots.length) {
        // vm.lotsKayit(0, "UPT", vm.RECEIPTID);

        vs.notify({
          title: "Kayıt",
          text: "Kayıt işlemleri başarılı",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          position: "top-center"
        });
        vm.siparisOku();
      } else {
        const args = {
          token: Store.state.tokenId,
          STOCKLOTSID: vm.kaydedilenLots[index].STOCKLOTSID,
          ROOT: "302",
          ROOTID: list[0].RECEIPTID,
          INSERTUSERID: vm.kaydedilenLots[index].INSERTUSERID,
          DEPOTID: vm.kaydedilenLots[index].DEPOTID,
          QUANTITY: vm.kaydedilenLots[index].QUANTITY,
          STOCKID: vm.secilenStok.STOCKID
        };
        soap.createClient(url, function (err, client) {
          client.STOCKLOTSTRANSADDMANUEL(args, function (err, result) {
            if (result.STOCKLOTSTRANSADDMANUELResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            vm.veriler = JSON.parse(result.STOCKLOTSTRANSADDMANUELResult);
            try {
              if (vm.veriler.response == "Ok") {
                //   vm.stokLotsTransAdd(index + 1);
                vm.addLotsList(index + 1, list);
              } else {
                vs.notify({
                  title: "Lot trans",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center"
                });
              }
            } catch (error) {
              console.log(error);
              vs.notify({
                title: "Lot trans",
                text: "Beklenmedik Hata",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          });
        });
      }
    },
    siparisKontrol() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      //alert(this.kdvDurumu)

      const args = {
        token: Store.state.tokenId,
        RECEIPTID: vm.siparisKod,
        userID: Store.state.MusteriId
      };
      let kontrolArr = []
      vm.uyumsuzMix = []
      vm.sipariseGoreUrunListesi.forEach((val, index) => {
        if (val.qt > 0 && val.lotqt != val.qt) {

        }
        if (val.STOCKID != val.MIXID) {

          let miktarUyumKontrol = vm.sipariseGoreUrunListesi.filter(post => {
            return post.STOCKID == val.STOCKID;
          });
          let miktarUyumMixKontrol = miktarUyumKontrol.filter(post => {
            console.log(post)
            return post.qt > 0;
          });
          console.log(miktarUyumMixKontrol.length)
          console.log(miktarUyumKontrol.length)

          if (miktarUyumMixKontrol.length != miktarUyumKontrol.length && miktarUyumMixKontrol.length != 0) {
            kontrolArr.push(false)
            vm.uyumsuzMix.push(val)
          }
        }

      });
      if (kontrolArr.toString().includes("false")) {
        vm.activePromptKontrol = true
        vs.notify({
          title: "Sipariş",
          text: "Mix de okutmadığınız ürünler var",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else {
        vm.activePromptSiparis = true
      }

    },
    removeTanim(index) {
      var vm = this;
      var vs = this.$vs;

      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        token: Store.state.tokenId,
        ISLEM: "DEL",
        RECEIPTID: this.RECEIPTID,
        MIXSTOCK: this.secilenStok.MIXID
      };

      soap.createClient(url, function (err, client) {
        client.addTempOrder(args, function (err, result) {
          if (result.addTempOrderResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.addTempOrderResult);
          try {
            if (vm.veriler.response == "Ok") {
              let lotsList = JSON.parse(vm.veriler.jsonData);

              vm.getLotForStock(vm.secilenStok.MIXID, vm.RECEIPTID);
              vm.siparisOku();
              vs.notify({
                title: "Reçete Listesi",
                text: "Silindi",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-right"
              });
            } else {
              vs.notify({
                title: "Reçete Listesi",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-right"
              });
            }
          } catch (error) {
            console.log(error);
            /*  vs.notify({
              title: "Reçete Listesi",
              text: "Beklenmedik Hata",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });*/
          }
        });
      });
    },
    kontrolOnayla() {
      var vm = this;
      var vs = this.$vs;

      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      console.log(vm.uyumsuzMix)
      vm.uyumsuzMix.forEach((val, index) => {
        const args = {
          token: Store.state.tokenId,
          ISLEM: "DELMIX",
          RECEIPTID: val.RECEIPTID,
          STOCKID: val.STOCKID
        };


        soap.createClient(url, function (err, client) {
          client.addTempOrder(args, function (err, result) {
            if (result.addTempOrderResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            vm.veriler = JSON.parse(result.addTempOrderResult);
            try {
              if (vm.veriler.response == "Ok") {
                let lotsList = JSON.parse(vm.veriler.jsonData);
                vm.activePromptSiparis = true;

                vm.siparisOku();
                vs.notify({
                  title: "Sipariş Listesi",
                  text: "Silindi",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-right"
                });
              } else {
                vs.notify({
                  title: "Sipariş Listesi",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-right"
                });
              }
            } catch (error) {
              console.log(error);

            }
          });
        });
      });

    },
    siparisYaz(drm) {
      // alert(anaStokKodu)
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      //alert(this.kdvDurumu)

      const args = {
        token: Store.state.tokenId,
        RECEIPTID: vm.siparisKod,
        userID: Store.state.MusteriId
      };


      soap.createClient(url, function (err, client) {
        client.addOrder(args, function (err, result) {
          vm.veriler = JSON.parse(result.addOrderResult);

          if (vm.veriler.response == "Ok") {
            vs.loading.close("#button-with-loading-partile > .con-vs-loading");
            vs.notify({
              title: "Sipariş Yazıldı",
              text: "Sipariş Yazıldı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center"
            });
            // vm.listeTemizle();

            let list = JSON.parse(vm.veriler.jsonData);
            if (vm.kaydedilenLots.length > 0) vm.addLotsList(0, list);
            else vm.siparisOku();
          } else {
            vs.notify({
              title: "Sipariş Yazılamadı",
              text: "Sipariş Yazmada Hata Oluştu",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "error",
              position: "top-center"
            });
          }
        });
      });
    },
    irsaliyeYaz() {
      // alert(anaStokKodu)
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        islemTipi: "irsaliye",
        cariKodu: this.selected.id,
        depoKodu: this.selectedDepo
      };
      // console.log(args)
      soap.createClient(url, function (err, client) {
        client.depoHizlisatisIslemi(args, function (err, result) {
          vm.veriler = JSON.parse(result.depoHizlisatisIslemiResult);
          if (vm.veriler.response == "Ok") {
            vs.loading.close("#button-with-loading-partile > .con-vs-loading");
            vs.notify({
              title: "İrsaliye Yazıldı",
              text: "İrsaliye Yazıldı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center"
            });
          } else {
            vs.notify({
              title: "İrsaliye Yazılamadı",
              text: "İrsaliye Yazmada Hata Oluştu",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "error",
              position: "top-center"
            });
          }
        });
      });
    },
    listedenCikar(id) {
      // alert(anaStokKodu)
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        id: id,
        cariKodu: this.selected.id,
        depoKodu: this.selectedDepo
      };
      soap.createClient(url, function (err, client) {
        client.hizliSatisSil(args, function () {
          vm.ps();
        });
      });
    },
    listeyiTemizle() {
      var vm = this;

      vm.sipariseGoreUrunListesi = [];
      var vm = this;
      var vs = this.$vs;

      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        token: Store.state.tokenId,
        ISLEM: "DELQT",
        RECEIPTID: this.RECEIPTID,
        MIXSTOCK: this.secilenStok.MIXID
      };

      soap.createClient(url, function (err, client) {
        client.addTempOrder(args, function (err, result) {
          if (result.addTempOrderResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.addTempOrderResult);
          try {
            if (vm.veriler.response == "Ok") {
              let lotsList = JSON.parse(vm.veriler.jsonData);
              vm.siparisOku();
              vs.notify({
                title: "Reçete Listesi",
                text: "Silindi",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-right"
              });
            } else {
              vs.notify({
                title: "Reçete Listesi",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-right"
              });
            }
          } catch (error) {
            console.log(error);
            /*  vs.notify({
              title: "Reçete Listesi",
              text: "Beklenmedik Hata",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });*/
          }
        });
      });
    },
    listedenCikar1(id, barkod) {
      // alert(anaStokKodu)
      this.barkodAdet = -1;
      this.barkod = barkod;
      this.barkodOku();
    },
    adetDegistir() {
      // alert(anaStokKodu)
      // alert(this.secilenKod)
      this.barkodAdet = this.partiVal;
      this.barkod = this.secilenKod;
      this.barkodOku("adetDegistir");
    },

    print() {
      // Pass the element id here
      this.$htmlToPaper("printMe");
    },
    indexbul(array, conditionFn) {
      const item = array.find(conditionFn);

      return array.indexOf(item);
    },
    ps1(text) {
      this.partiVal = text;
    },
    ps() {
      var vm = this;
      vm.sipariseGoreUrunListesi = null;
      vm.sipariseGoreUrunListesi = "";
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        cariKodu: this.selected.id,
        depoKodu: this.selectedDepo,
        islemTipi: 0,
        aranan: this.barkod
      };
      soap.createClient(url, function (err, client) {
        client.acikHizliSiparis(args, function (err, result) {
          vm.veriler = JSON.parse(result.acikHizliSiparisResult);
          vm.gecerlilikTarihi = vm.veriler[0].gecerlilikTarihi;
          vm.sipariseGoreUrunListesi = vm.veriler;
        });
      });
    },
    ekleButtonPs() {
      this.barkod = "";
      var vm = this;
      vm.sipariseGoreUrunListesi = null;
      vm.sipariseGoreUrunListesi = "";
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        cariKodu: this.selected.id,
        depoKodu: this.selectedDepo,
        islemTipi: 0,
        aranan: this.barkod
      };
      soap.createClient(url, function (err, client) {
        client.acikHizliSiparis(args, function (err, result) {
          vm.veriler = JSON.parse(result.acikHizliSiparisResult);

          // vm.gecerlilikTarihi = vm.veriler[0].gecerlilikTarihi;
          vm.sipariseGoreUrunListesi = vm.veriler;
        });
      });
    },

    secilenPartiUrunleri() {
      const vs = this.$vs;

      if (this.pazaryeriVal == "" || this.partiVal == "") {
        vs.notify({
          title: "Paketleme",
          text: "Pazaryerini ve Parti Seçiniz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else {
        var vm = this;

        const soap = require("soap");
        const url = state.sistemAddress;

        const args = {
          pazaryeri: this.pazaryeriVal,
          partiNo: this.partiVal,
          token: Store.state.tokenId
        };
        soap.createClient(url, function (err, client) {
          client.partiUrunleri(args, function (err, result) {
            if (result.partiUrunleriResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            } else {
              vm.veriler = JSON.parse(result.partiUrunleriResult);
              vm.total = vm.veriler[0]["tt"];
              vm.list = vm.veriler;

              vm.popupActive = true;
            }
          });
        });
      }
    },
    faturaBul() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        program: this.pazaryeriVal,
        EMPLOYEEID: Store.state.plasiyer,
        faturaAranan: vm.faturaBulOrderNumber
      };
      soap.createClient(url, function (err, client) {
        client.sonFaturalar(args, function (err, result) {
          if (result.sonFaturalarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.veriler = JSON.parse(result.sonFaturalarResult);
            //.log(vm.veriler)
            vm.listSonFaturalar = vm.veriler;

            vm.popupFatura = true;
          }
        });
      });
    },
    siparisBul() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      // alert(this.pazaryeriVal)
      const args = {
        pazaryeri: "Trendyol",
        token: Store.state.tokenId,
        sayfa: 0,
        orderNumber: this.siparisBulOrderNumber
      };
      soap.createClient(url, function (err, client) {
        client.iadeListele(args, function (err, result) {
          if (result.iadeListeleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.veriler = JSON.parse(result.iadeListeleResult);
            vm.listSiparis = vm.veriler;
            vm.popupActiveSiparis = true;
          }
        });
      });
    },
    siparisSec() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      // alert(this.pazaryeriVal)
      const args = {
        pazaryeri: "Trendyol",
        token: Store.state.tokenId,
        sayfa: 0,
        orderNumber: ""
      };
      soap.createClient(url, function (err, client) {
        client.iadeListele(args, function (err, result) {
          if (result.iadeListeleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.veriler = JSON.parse(result.iadeListeleResult);
            vm.listSiparis = vm.veriler;
            vm.popupActiveSiparis = true;
          }
        });
      });
    },
    urunOku() {
      const vs = this.$vs;
      const vm = this;
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      if (vm.selectedAnaSiparis == "") {
        vs.notify({
          title: "Sipariş",
          text: "Sipariş seçimi yapmadınız",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else {
        let gonderilecek = 0.0;
        if (vm.urunMiktar == "") vm.urunMiktar = 1;

        const args = {
          token: Store.state.tokenId,
          LOTNO: vm.urunKod,
        };

        soap.createClient(url, function (err, client) {
          client.STOCKLOTSLIST(args, function (err, result) {
            if (result.STOCKLOTSLISTResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.STOCKLOTSLISTResult);
              let lotListesi = JSON.parse(vm.veriler.jsonData);
              console.log(lotListesi);
              console.log(vm.selectedAnaSiparis);
              if (vm.veriler.response == "Ok") {

                if (lotListesi.length > 0) {
                  let mikTanim = 0;
                  let miktarUyumKontrol = vm.sipariseGoreUrunListesi.filter(
                    post => {
                      return (
                        post.MIXID == lotListesi[0].STOCKID &&
                        post.STOCKNO.toString().toUpperCase() ==
                        vm.selectedAnaSiparis.toString().toUpperCase()
                      );
                    }
                  );
                  console.log(miktarUyumKontrol);
                  if (miktarUyumKontrol.length == 0) {
                    vs.notify({
                      title: "Ürün okuma",
                      text: "Okutulan ürün sipariş listesinde bulunmuyor",
                      iconPack: "feather",
                      icon: "icon-alert-circle",
                      color: "warning",
                      position: "top-center"
                    });
                  } else {
                    console.log(lotListesi[0].QREM - lotListesi[0].rezerveQt5)
                    if (lotListesi[0].QREM - lotListesi[0].rezerveQt5 >= 0) {
                      console.log(lotListesi[0].QREM - lotListesi[0].rezerveQt5)
                      if (lotListesi[0].QREM - lotListesi[0].rezerveQt5 >= vm.urunMiktar) {
                        console.log("in")
                        if (isNaN(parseFloat(miktarUyumKontrol[0].qt) == true))
                          miktarUyumKontrol[0].qt = 0.0;

                        if (
                          parseFloat(miktarUyumKontrol[0].QREM) <
                          parseFloat(miktarUyumKontrol[0].qt) +
                          parseFloat(vm.urunMiktar)
                        ) {
                          vs.notify({
                            title: "Ürün okuma",
                            text: "Stoklarda bulunmuyor",
                            iconPack: "feather",
                            icon: "icon-alert-circle",
                            color: "warning",
                            position: "top-center"
                          });
                        } else if (
                          miktarUyumKontrol[0].KALAN == miktarUyumKontrol[0].qt
                        ) {
                          console.log("kkkk");
                          vs.notify({
                            title: "Ürün okuma",
                            text: "Okunan ürün adedi ile sipariş adedi eşit",
                            iconPack: "feather",
                            icon: "icon-alert-circle",
                            color: "warning",
                            position: "top-center"
                          });
                        } else {
                          if (vm.urunMiktar > miktarUyumKontrol[0].KALAN) {
                            if (
                              miktarUyumKontrol[0].KALAN + miktarUyumKontrol[0].qt >
                              vm.urunMiktar
                            )
                              gonderilecek =
                                vm.urunMiktar -
                                (miktarUyumKontrol[0].KALAN +
                                  miktarUyumKontrol[0].qt);
                            else gonderilecek = miktarUyumKontrol[0].KALAN;
                          } else {
                            if (
                              parseFloat(vm.urunMiktar) +
                              parseFloat(miktarUyumKontrol[0].qt) >
                              parseFloat(miktarUyumKontrol[0].KALAN)
                            ) {
                              gonderilecek =
                                parseFloat(miktarUyumKontrol[0].KALAN) -
                                parseFloat(miktarUyumKontrol[0].qt);
                            } else {
                              gonderilecek = parseFloat(vm.urunMiktar);
                            }
                          }
                          const soap = require("soap");
                          let url = state.sistemAddress;
                          url = url.replace("sistem", "uzumMrp");
                          console.log(miktarUyumKontrol);

                          const args = {
                            token: Store.state.tokenId,
                            ROOT: "103",
                            ISLEM: "EKLE",
                            RECEIPTNO: miktarUyumKontrol[0].RECEIPTNO,
                            STOCKID: miktarUyumKontrol[0].STOCKID,
                            ITEMNO: miktarUyumKontrol[0].ITEMNO,
                            LOTID: lotListesi[0].STOCKLOTSID,
                            QUANTITY: miktarUyumKontrol[0].QUANTITY,
                            RECEIPTID: miktarUyumKontrol[0].RECEIPTID,
                            MIXSTOCK: miktarUyumKontrol[0].MIXID,
                            MIXOKUNAN: gonderilecek,
                            LOTOKUNAN: miktarUyumKontrol[0].qt + gonderilecek,
                            LOTNO: lotListesi[0].LOTNO,
                            STOCKNO: vm.urunKod,
                            LOTDEPO: lotListesi[0].DEPOTID
                          };
                          console.log(args);

                          soap.createClient(url, function (err, client) {
                            client.addTempOrder(args, function (err, result) {
                              console.log(result);
                              vm.veriler = JSON.parse(result.addTempOrderResult);
                              let listOrder = JSON.parse(vm.veriler.jsonData);
                              vs.notify({
                                title: "Lot Ekleme",
                                text: "Ekleme başarılı",
                                iconPack: "feather",
                                icon: "icon-alert-circle",
                                color: "success",
                                position: "top-center"
                              });
                              vm.siparisOku();
                              vm.urunKod = "";
                              vm.urunMiktar = "";
                            });
                          });
                        }
                      } else {
                        vs.notify({
                          title: "Lot Ekleme",
                          text: "Girilen miktar lot adadini aşıyor. Kalan lot miktarı: " + (parseFloat(lotListesi[0].QREM) - parseFloat(lotListesi[0].rezerveQt5)).toString(),
                          iconPack: "feather",
                          icon: "icon-alert-circle",
                          color: "warning",
                          position: "top-center"
                        });
                      }

                    }

                  }
                } else {
                  vs.notify({
                    title: "Lot Ekleme",
                    text: "Lot kaydının sistemden kayıtlı olduğundan emin olun",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                    position: "top-center"
                  });
                }
              } else
                vs.notify({
                  title: "Lot Ekleme",
                  text: "Lot kaydının sistemden kayıtlı olduğundan emin olun",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center"
                });
            } catch (error) {
              console.log(error);
              vs.notify({
                title: "Lot Ekleme",
                text: "Lot Kaydı sırasında hata oluştu",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          });
        });
        /*else {
          let miktarUyumKontrol = vm.sipariseGoreUrunListesi.filter(post => {
            if (
              post.MIXNO == "" ||
              typeof post.MIXNO == "undefined" ||
              post.MIXNO === "" ||
              post.MIXNO == null
            ) {
              return (
                post.STOCKNO.toString().toUpperCase() ==
                  vm.urunKod.toString().toUpperCase() &&
                post.RECEIPTNO.toString().toUpperCase() ==
                  vm.siparisKod.toString().toUpperCase() &&
                post.STOCKNO.toString().toUpperCase() ==
                  vm.selectedAnaSiparis.toString().toUpperCase()
              );
            } else {
              return (
                post.MIXNO.toString().toUpperCase() ==
                  vm.urunKod.toString().toUpperCase() &&
                post.RECEIPTNO.toString().toUpperCase() ==
                  vm.siparisKod.toString().toUpperCase() &&
                post.STOCKNO.toString().toUpperCase() ==
                  vm.selectedAnaSiparis.toString().toUpperCase()
              );
            }
          });
          console.log(miktarUyumKontrol);
          if (miktarUyumKontrol.length == 0) {
            vs.notify({
              title: "Ürün okuma",
              text: "Okutulan ürün sipariş listesinde bulunmuyor",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center"
            });
          } else {
            if (
              miktarUyumKontrol[0].QREM <
              isNaN(parseFloat(miktarUyumKontrol[0].qt) == true)
                ? parseFloat(vm.urunMiktar)
                : parseFloat(miktarUyumKontrol[0].qt) +
                  parseFloat(vm.urunMiktar)
            ) {
              vs.notify({
                title: "Ürün okuma",
                text: "Stoklarda bulunmuyor",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center"
              });
            } else if (miktarUyumKontrol[0].KALAN == miktarUyumKontrol[0].qt) {
              vs.notify({
                title: "Ürün okuma",
                text: "Okunan ürün adedi ile sipariş adedi eşit",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center"
              });
            } else {
              if (vm.urunMiktar > miktarUyumKontrol[0].KALAN) {
                gonderilecek =
                  parseFloat(miktarUyumKontrol[0].KALAN) -
                  isNaN(parseFloat(miktarUyumKontrol[0].qt) == true)
                    ? 0
                    : miktarUyumKontrol[0].qt;
              } else {
                if (
                  parseFloat(vm.urunMiktar) +
                    parseFloat(miktarUyumKontrol[0].qt) >
                  parseFloat(miktarUyumKontrol[0].KALAN)
                ) {
                  gonderilecek =
                    parseFloat(miktarUyumKontrol[0].KALAN) -
                    parseFloat(miktarUyumKontrol[0].qt);
                } else {
                  gonderilecek = parseFloat(vm.urunMiktar);
                }
              }
              console.log(gonderilecek);
              const soap = require("soap");
              let url = state.sistemAddress;
              url = url.replace("sistem", "uzumMrp");

              const args = {
                token: Store.state.tokenId,
                ROOT: "103",
                RECEIPTNO: miktarUyumKontrol[0].RECEIPTNO,
                STOCKID: miktarUyumKontrol[0].STOCKID,
                ITEMNO: miktarUyumKontrol[0].ITEMNO,
                LOTID: miktarUyumKontrol[0].LOTID,
                QUANTITY: miktarUyumKontrol[0].QUANTITY,
                RECEIPTID: miktarUyumKontrol[0].RECEIPTID,
                MIXSTOCK: miktarUyumKontrol[0].MIXID,
                MIXOKUNAN: gonderilecek,
                LOTOKUNAN: 0,
                LOTNO: 0
              };
              console.log(args);
              soap.createClient(url, function(err, client) {
                client.addTempOrder(args, function(err, result) {
                  console.log(result);
                  vm.veriler = JSON.parse(result.addTempOrderResult);
                  let listOrder = JSON.parse(vm.veriler.jsonData);
                  vm.siparisOku();
                });
              });
            }
          }
        }*/
      }
    },
    siparisOku(islemNe) {
      // alert(gelenorder)

      const vm = this;
      const vs = this.$vs;
      vm.text = vm.barkod;

      if (vm.barkodAdet == "") {
        vm.barkodAdet = 1;
      }
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");

      const args = {
        token: Store.state.tokenId,
        RECEIPTID: vm.siparisKod
      };
      soap.createClient(url, function (err, client) {
        client.getOrderDetails(args, function (err, result) {
          vm.veriler = JSON.parse(result.getOrderDetailsResult);
          let listOrder = JSON.parse(vm.veriler.jsonData);

          if (listOrder.length > 0) {
            //   vm.onayMuzik();
            //  vm.gecerlilikTarihi=listOrder[0].gecerlilikTarihi

            //alert(vm.sipariseGoreUrunListesi.length)

            vm.sipariseGoreUrunListesi = listOrder;
            console.log(vm.sipariseGoreUrunListesi);
            vm.RECEIPTNO = vm.sipariseGoreUrunListesi[0].RECEIPTNO;
            vm.RECEIPTID = vm.sipariseGoreUrunListesi[0].RECEIPTID;
            vm.DEPOTID = vm.sipariseGoreUrunListesi[0].depo;

            vm.siparisYazdirKontrol = false;
            listOrder.forEach((val, index) => {
              if (val.qt == null) vm.siparisYazdirKontrol = true;
            });
            vm.optionsAnaSiparis = [...new Set(listOrder.map(x => x.STOCKNO))];
            vm.kaydedilenLots = [];
            vm.urunKod = "";
            vm.urunMiktar = "";
            /*
              vm.indext = vm.indexbul(
                vm.sipariseGoreUrunListesi,
                item => item.STOCKNO.replace(" ", "") === listOrder[0].STOCKNO
              );

              vm.sipariseGoreUrunListesi[vm.indext].QUANTITY =
                listOrder[0].QUANTITY;
              vm.sipariseGoreUrunListesi[vm.indext].CURRDATE =
                listOrder[0].CURRDATE;
              // console.log(listOrder[0])
              // vm.sipariseGoreUrunListesi.push(listOrder[0])
              // console.log(vm.sipariseGoreUrunListesi)*/
          } else {
            // vm.hataMuzik();
          }
          vm.barkod = "";
          vm.barkodAdet = "";

          //document.getElementById("barkodM").focus();
          //   vm.ekleButtonPs();
        });
      });
    },

    stokGuncelle() {
      const vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = { program: "Trendyol", token: Store.state.tokenId };
      soap.createClient(url, function (err, client) {
        client.stokAdetFiyatGuncelle(args, function (err, result) {
          if (result.stokAdetFiyatGuncelleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.stokAdetFiyatGuncelleResult);
        });
      });
    },
    tekrarIslemeAl(orderNumber, merchantSku, partiNo) {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      // alert(this.pazaryeriVal)
      const args = {
        pazaryeri: this.pazaryeriVal.trim(),
        token: Store.state.tokenId,
        orderNumber: orderNumber
      };
      soap.createClient(url, function (err, client) {
        client.tekrarIslemeAl(args, function (err, result) {
          if (result.siparisListeleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.siparisHazirla(orderNumber, merchantSku, partiNo);
          }
        });
      });
    },

    listeTemizle() {
      this.sipariseGoreUrunListesi = [];
      this.validated = 1;
      this.eklenenToplamParca = 0;
    },
    isMobile: function () {
      /*	var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;*/
      return isMobile;
    }
  },
  beforeMount() {
    //  console.log(Store.state.UserId)
    //setInterval(this.stokGuncelle,900000);

    var vm = this;
    //document.getElementById("barkodM").focus()
    const soap = require("soap");
    let url = state.sistemAddress;
    url = url.replace("sistem", "uzumMrp");
    const args = {}; /*
    soap.createClient(url, function(err, client) {
      client.cariBul(args, function(err, result) {
        vm.veriler = JSON.parse(result.cariBulResult);
        //vm.pazaryeriTum=vm.veriler
        //   console.log(vm.veriler);
        vm.options = vm.veriler;
      });
    });*/
  }
};
</script>

<style lang="scss" scoped>
.scroll-hand {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}

.satirRengi {
  background-color: green;
  color: white;
}

.v-select .vs__selected {
  font-size: 10px;
}

.mb-base {
  margin-bottom: 0.75rem !important;
}

.list-view-item {

  .item-name,
  .item-description {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .item-name {
    -webkit-line-clamp: 2;
  }

  .item-description {
    -webkit-line-clamp: 5;
  }

  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: 0.35s;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

    .grid-view-img {
      opacity: 0.9;
    }
  }
}
</style>
<style lang="stylus">
#parentx {
  overflow: hidden;
  height: 500px;
  position: relative;
}

.header-sidebar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;

  h4 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    > button {
      margin-left: 10px;
    }
  }
}

.footer-sidebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  > button {
    border: 0px solid rgba(0, 0, 0, 0) !important;
    border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
    border-radius: 0px !important;
  }
}
.vs-notifications {
  z-index: 200000000000 !important;
}
</style>
